
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d61i2j8omoleh5thvklg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: 'العنوان',
      content: 'الرياض، المملكة العربية السعودية'
    },
    {
      icon: 'ri-phone-line',
      title: 'الهاتف',
      content: '+966 50 123 4567'
    },
    {
      icon: 'ri-mail-line',
      title: 'البريد الإلكتروني',
      content: 'info@dropshop.sa'
    },
    {
      icon: 'ri-time-line',
      title: 'ساعات العمل',
      content: 'السبت - الخميس: 9:00 ص - 6:00 م'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              تواصل معنا
            </h1>
            <p className="text-lg max-w-2xl mx-auto text-gray-400">
              نحن هنا لمساعدتك! لا تتردد في التواصل معنا لأي استفسار أو اقتراح
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            <div>
              <h2 className="text-2xl font-bold mb-8 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                معلومات التواصل
              </h2>
              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start gap-4 p-6 rounded-xl" style={{ backgroundColor: '#1B2D3E' }}>
                    <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: 'rgba(212, 168, 75, 0.15)' }}>
                      <i className={`${info.icon} text-2xl`} style={{ color: '#D4A84B' }}></i>
                    </div>
                    <div>
                      <h3 className="font-bold mb-1 text-white">{info.title}</h3>
                      <p className="text-gray-400">{info.content}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8">
                <h3 className="font-bold mb-4 text-white">تابعنا على</h3>
                <div className="flex items-center gap-4">
                  <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full transition-colors cursor-pointer" style={{ backgroundColor: '#1B2D3E' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1B2D3E'}
                  >
                    <i className="ri-facebook-fill text-white text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full transition-colors cursor-pointer" style={{ backgroundColor: '#1B2D3E' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1B2D3E'}
                  >
                    <i className="ri-twitter-fill text-white text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full transition-colors cursor-pointer" style={{ backgroundColor: '#1B2D3E' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1B2D3E'}
                  >
                    <i className="ri-instagram-fill text-white text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full transition-colors cursor-pointer" style={{ backgroundColor: '#1B2D3E' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1B2D3E'}
                  >
                    <i className="ri-linkedin-fill text-white text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-2xl p-8" style={{ backgroundColor: '#1B2D3E' }}>
              <h2 className="text-2xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                أرسل لنا رسالة
              </h2>
              <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      الاسم الكامل
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      required
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="أدخل اسمك الكامل"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      البريد الإلكتروني
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      required
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="example@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      رقم الهاتف
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="+966 50 123 4567"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      الموضوع
                    </label>
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={(e) => setFormData({...formData, subject: e.target.value})}
                      required
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="موضوع الرسالة"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      الرسالة
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent resize-none text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="اكتب رسالتك هنا (حد أقصى 500 حرف)"
                    ></textarea>
                    <p className="text-xs mt-1 text-gray-400">
                      {formData.message.length}/500 حرف
                    </p>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full px-6 py-4 text-black font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                    style={{ backgroundColor: '#D4A84B' }}
                    onMouseEnter={(e) => !isSubmitting && (e.currentTarget.style.backgroundColor = '#E5B95C')}
                    onMouseLeave={(e) => !isSubmitting && (e.currentTarget.style.backgroundColor = '#D4A84B')}
                  >
                    {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
                  </button>

                  {submitStatus === 'success' && (
                    <div className="p-4 bg-green-900/50 border border-green-500 rounded-lg text-green-400 text-sm">
                      تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="p-4 bg-red-900/50 border border-red-500 rounded-lg text-red-400 text-sm">
                      حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
